import React, { useState, useEffect } from 'react'
import fb from '../../../assets/img/custom/social/fb.png'
import twitter from '../../../assets/img/custom/social/twitter.png'
import yt from '../../../assets/img/custom/social/yt.png'
import linked from '../../../assets/img/custom/social/linked.png'
import insta from '../../../assets/img/custom/social/insta.png'
import logo from '../../../assets/img/logo_new.png'
import Swal from 'sweetalert2';
import API from '../../../utils/api'
import { useTranslation } from 'react-i18next';
import { IoLogoInstagram, IoLocationOutline, IoCallOutline, IoMailOutline } from "react-icons/io5";
import Map from '../../ContactTwo/Map'

const FooterTop = () => {
    const { t, i18n } = useTranslation();
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const sendMessage = () => {

        API.contact().create({
            name: name,
            mobile: mobile,
            email: email,
            message: message,
        })
            .then(response => {

                if (response.status === 200) {
                    Swal.fire('Thanks!', "Message sent successfully.", 'success')
                    setName('');
                    setMobile('')
                    setEmail('')
                    setMessage('')
                }

            })

    }

    return (
        <div style={{ background: '#FEFAFA' }}>
            <section className='container' id='footer-form'>

                <div className='row py-5'>
                    <div className='col-lg-4 col-12' >
                        <div className='px-5 pb-5 pt-2'>
                            <h3 className='font-weight-light mb-3'>{t('contactus')}</h3>
                            <p>{t('addressline1')} <br />{t('addressline2')} <br />{t('addressline3')} <br />{t('addressline4')} <br /><span>{t('addressline5')}</span> <br />{t('addressline6')}</p>
                        </div>
                    </div>
                    <div className='col-lg-4 col-12'>
                        
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3631.575927208687!2d54.3667803!3d24.4654942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e6618588616c1%3A0xa3da25b1441c86c4!2zQWRhbSZFdmUgU3BlY2lhbGl6ZWQgTWVkaWNhbCBDZW50ZXIgfCBDb3NtZXRpY3MgfCDZhdix2YPYsiDYp9iv2YUg2YjYrdmI2KfYoSDYp9mE2LfYqNmKINin2YTYqtiu2LXYtdmKINin2YTYqtis2YXZitmE2Yo!5e0!3m2!1sen!2sin!4v1677604067817!5m2!1sen!2sin" width="100%"
                            height="90%"
                            style={{ border: 0 }}
                            loading="lazy" allowfullscreen referrerpolicy="no-referrer-when-downgrade" />
                    </div>
                    <div className='col-lg-4 col-12 px-5 workinghrs'>
                        <h3 className='font-weight-light mb-3'>{t('workinghours')}</h3>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('sunday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                10:00{t('am')} - 09:00{t('pm')}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('monday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                10:00{t('am')} - 09:00{t('pm')}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('tueday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                10:00{t('am')} - 09:00{t('pm')}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('wednesday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                10:00{t('am')} - 09:00{t('pm')}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('thursday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                10:00{t('am')} - 09:00{t('pm')}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('friday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                10:00{t('am')} - 09:00{t('pm')}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-5 text-black-50'>
                                {t('saturday')}
                            </div>
                            <div className='col-xl-8 col-7 text-black-50 text-right'>
                                {t('closed')}
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <section id="pharmacy_footer_top">
                <div className="container border-bottom-footer">
                    <div className="row">
                        <div className="col-md-4 col-sm-6 co-12 border-right-footer">
                            <div className="pharmacy_footer_text">
                         
                                            <a href="https://www.facebook.com/adamandevecosmeticmedicalcenter/" target='_blank'>
                                            <img className='social-icon-circle-ft' src={fb}/>
                                            </a>

                                            <a href="http://www.twitter.com/" className='ml-2' target='_blank'>
                                            <img className='social-icon-circle-ft' src={twitter}/>
                                            </a>
                                            <a href="https://www.linkedin.com/" className='ml-2' target='_blank'>
                                            <img className='social-icon-circle-ft' src={linked}/>
                                            </a>
                                            <a href="https://www.instagram.com/adamandeve_aecmc/" target='_blank' className='ml-2'>
                                            <img className='social-icon-circle-ft' src={insta}/>
                                            </a>
                                            <a href="https://www.youtube.com/channel/UCjkpOCn2aIhUb6HS0msenkw" target='_blank' className='ml-2'>
                                            <img className='social-icon-circle-ft' src={yt}/>
                                            </a>

                                     
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6 co-12 border-right-footer">
                            <div className="pharmacy_footer_text">
                            <a href="#!">
                                            <img src={logo}/>
                                            </a>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6 co-12">
                            <div className="pharmacy_footer_text">
                                <small className='font-weight-light'>{t('footerabout')}</small>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </section> */}
        </div>
    )
}

export default FooterTop